import { useEffect, useState } from "react";
import { getFeatureName, valueToColor } from "../../../util/helperFunctions";
import { toast } from "react-toastify";
import { azureFetch } from "../../../api/azureFetch";


function useGetLiveModelTC(selectedSensor, debouncedNumberOfTopContributors) {

    const [data, setData] = useState(null);
    const [count, setCount] = useState(10);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        if (debouncedNumberOfTopContributors > 0) {
            setLoading(true);
            azureFetch("TopContributors", {
                id: selectedSensor,
                limit: debouncedNumberOfTopContributors,
                category: 0
            }).then((res) => {
                if (res.objs && res.objs.length > 0) {
                    const dataToPlot = [
                        {
                            type: "bar",
                            marker: {
                                color: res.objs.map((item) =>
                                    valueToColor(item.negativeValue)
                                ),
                                width: 1,
                            },
                            x: res.objs.map((item) => item.value),
                            y: res.objs.map((item) => {
                                const name = item.name;
                                return getFeatureName(name);
                            }),
                            orientation: "h",
                        },
                    ]
                    setData(dataToPlot);
                    setCount(res.count);
                }
            }).catch((error) => {
                console.log(error);
                toast.error(`Cannot fetch Top Contributors data`);
            }).finally(() => {
                setLoading(false);
            });
        }

    }, [selectedSensor, debouncedNumberOfTopContributors])

    return {
        data,
        count,
        loading,
    };
}

export default useGetLiveModelTC;